import type { estypes } from '@elastic/elasticsearch';
import styles from './debugging-info.module.scss';
import Button from 'components/controls/buttons/button';
import {
	JsonView,
	collapseAllNested,
	defaultStyles,
} from 'react-json-view-lite';
import CopyToClipboard from 'components/copy-to-clipboard';
import { useState } from 'react';

export const DebuggingInfo = ({
	score,
	highlights,
	accessionNumber,
	sortArtist,
	yearFrom,
	yearTo,
	elasticSearchId,
	handleExplain,
	explanation,
}: IDebuggingInfo) => {
	const [hide, setHide] = useState(false);

	if (hide) {
		return null;
	}

	return (
		<div className={styles.container}>
			<button
				style={{ float: 'right' }}
				onClick={() => {
					setHide(true);
				}}
			>
				[Hide]
			</button>
			<br />
			{!!score && (
				<div className={styles.data}>
					<b>score</b>: {score}
				</div>
			)}
			{accessionNumber && (
				<div className={styles.data}>
					<b>accessionNumber:</b>
					{accessionNumber}
				</div>
			)}
			<div className={styles.data}>
				<b>sortArtist:</b>
				{sortArtist}
			</div>
			<div className={styles.data}>
				<b>yearFrom:</b>
				{yearFrom}
			</div>
			<div className={styles.data}>
				<b>yearTo:</b>
				{yearTo}
			</div>
			{highlights && (
				<ul>
					{Object.keys(highlights).map((fieldName) => {
						return (
							<li className={styles.highlight} key={fieldName}>
								<b>{fieldName}:</b>{' '}
								{highlights[fieldName].map((highlight) => (
									<span
										style={{ display: 'inline-block' }}
										key={highlight}
										dangerouslySetInnerHTML={{ __html: highlight }}
									></span>
								))}
							</li>
						);
					})}
				</ul>
			)}
			{!highlights && (
				<p>
					<br />
					[Add &showHighlights=1 to the URL to show text highlights]
				</p>
			)}
			<Button
				className={styles.explainButton}
				appearance="secondary"
				value={elasticSearchId}
				onClick={handleExplain}
			>
				Explain
			</Button>
			{explanation && (
				<JsonView
					data={explanation}
					style={defaultStyles}
					shouldExpandNode={collapseAllNested}
				/>
			)}
			{explanation && (
				<div className={styles.explainButton}>
					<CopyToClipboard
						message={'Copy 📋'}
						text={JSON.stringify(explanation)}
					/>
				</div>
			)}
		</div>
	);
};

export interface IDebuggingInfo {
	elasticSearchId?: string;
	explanation?: estypes.ExplainResponse;
	handleExplain?: (event: React.MouseEvent<HTMLButtonElement>) => void;
	accessionNumber?: string;
	highlights?: Record<string, string[]>;
	score?: number;
	sortArtist?: any;
	yearFrom?: number;
	yearTo?: number;
}
